import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { Mosaic, MosaicParent, MosaicWindow } from 'react-mosaic-component';
import 'react-mosaic-component/react-mosaic-component.css';
import { ViewId } from './models';
import { styleSheet } from './styles';

export function HostedBlogPreviewSplitView({
	styles = [],
	leftNode,
	rightNode,
	minimumSplitPercentage = 5,
	splitPercentage,
	leftToolbarNode,
	rightToolbarNode,
	onSplitPercentageChange,
	onIsDraggingDividerChange,
}: {
	styles?: StyleDeclarationValue[];
	leftNode?: React.ReactNode;
	rightNode?: React.ReactNode;
	leftToolbarNode?: React.ReactNode;
	rightToolbarNode?: React.ReactNode;
	splitPercentage: number;
	minimumSplitPercentage?: number;
	onSplitPercentageChange: (splitPercentage: number) => void;
	onIsDraggingDividerChange?: (isDraggingDivider: boolean) => void;
}) {
	const split = Math.min(Math.max(splitPercentage, minimumSplitPercentage), 100 - minimumSplitPercentage);
	const mosaicSplit = React.useMemo<MosaicParent<ViewId>>(
		() => ({
			direction: 'row',
			first: 'left',
			second: 'right',
			splitPercentage: split,
		}),
		[split]
	);
	const [isDraggingDivider, setIsDraggingDivider] = React.useState<boolean>(false);

	return (
		<Mosaic<ViewId>
			className={css(
				mosaicSplit.splitPercentage >= 90 ? styleSheet.splitContainerShadowRight : null,
				mosaicSplit.splitPercentage <= 10 ? styleSheet.splitContainerShadowLeft : null,
				...styles,
				isDraggingDivider ? styleSheet.splitContainerDisabledTransitons : null
			)}
			onRelease={() => {
				setIsDraggingDivider(false);
				onIsDraggingDividerChange?.(false);
			}}
			onChange={v => {
				const settings = v as MosaicParent<ViewId>;
				setIsDraggingDivider(true);

				onIsDraggingDividerChange?.(true);
				onSplitPercentageChange(settings.splitPercentage);
			}}
			renderTile={(id, path) => (
				<MosaicWindow
					className={css(styleSheet.splitViewWindow)}
					draggable={false}
					path={path}
					title=''
					toolbarControls={id === 'left' ? leftToolbarNode : rightToolbarNode}
				>
					{id === 'left' ? leftNode : rightNode}
				</MosaicWindow>
			)}
			initialValue={mosaicSplit}
			resize={{ minimumPaneSizePercentage: 5 }}
			value={mosaicSplit}
		/>
	);
}
